module.exports = __webpack_public_path__ + "img/img-crm-empty.848bf5ea.png";